<template>
  <div class="column is-12 theme">
    <lightbox :show="lightboxSrc !== ''" @onclose="lightboxSrc = ''" :image="lightboxSrc" :closeOnAnywhere="true"></lightbox>
    <transition name="theme" mode="out-in">
      <div v-if="show" class="container">
        <a class="delete" @click.prevent="$emit('close-theme')"></a>
        <h3 class="title is-3" v-html="themeObj.Title"></h3>
        <p class="has-text-weight-bold" v-html="themeObj.Introduction"></p>
        <div class="content" :key="resetComponent" v-html="themeObj.Html.replace(/\/files\//g, ($store.state.imgBase + 'files/'))" @click="handleClick"></div>
        <a v-if="themeObj.DownloadPdf != ''" :href="$store.state.imgBase + themeObj.DownloadPdf + '?v=' + +new Date(themeObj.StartMoment)" class="button is-primary">Download</a>
      </div>
    </transition>
  </div>
</template>

<script>

import { getFilenameFromUrl } from '@/mixins/getFilenameFromUrl.js'
import lightbox from '@/components/Lightbox.vue'

export default {
  name: 'homeTheme',
  props: {
    show: Boolean,
    theme: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      lightboxSrc: '',
      resetComponent: +new Date()
    }
  },
  mixins: [getFilenameFromUrl],
  components: {
    lightbox
  },
  computed: {
    themeObj () {
      return typeof this.theme === 'undefined' ? {} : this.theme
    },
    activePage () {
      return this.$store.state.activePage
    }
  },
  methods: {
    handleClick: function (e) {
      var self = this
      if (e.target.nodeName === 'IMG' && e.target.closest('figure').classList.contains('is-enlargeable')) {
        var file = self.getFilenameFromUrl(e.target.src)
        if (file) {
          e.preventDefault()
          var img = new Image()
          img.onload = function () {
            self.lightboxSrc = file.fullUrl
          }
          img.src = file.fullUrl
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.theme{
  padding-top: 0;
  padding-bottom: 0;
  .container{
    padding: 20px 0 40px 0;
    border-bottom: 1px solid $grey-lighter;
    transition: all 1s ease;
    max-height: 10000px;
    overflow: hidden;

    .delete{
      position: absolute;
      right: .5rem;
      top: 1rem;
    }

    .content, .title.is-3{
      margin-top: 2rem;
      padding: 0px 10px;
    }
    .content, .has-text-weight-bold{
      padding: 0px 10px;
    }
    .content{
      @media screen and (min-width: $bp-tablet){
        column-count: 2;
        column-gap: 40px;
      }
      padding: 0px 10px;
    }
    >a.button{
      margin: 0 10px;
    }

    @include content;

    &.theme-enter, &.theme-leave-to{
      max-height: 0;
      opacity: 0;
    }
  }
}
// .column>div {
//     transition: all .6s ease;
//     max-height: 2000px;
//     // background-color: #eee;
//     overflow: hidden;
// }
// .column>div.theme-enter, .column>div.theme-leave-to {
//     max-height: 0;
//     opacity: 0;
// }

@media screen and (max-width: $bp-tablet - 1px){
  .container{
    padding: 0 10px;
  }
}
</style>
